import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetVehicleApprovalService {

  constructor(private http: HttpClient) { }
  private token = '';

  getcampusdetail() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCampuses', { headers });
  }

  getvehicletable(campusId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/vehicleAssetTracking/campusWiseVehicleDetails?campusId=' + campusId, { headers })
  }

  postApproval(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.orgUrl + '/apiV2/assetTracking/saveAssetApprovalDetails', payload, { headers })
  }

}
